import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getArticle } from "@/lib/api";
import JournalSubscribe from "@/components/JournalSubscribe";

export default function JournalDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => {
    setA(null);
    getArticle(slug).then(setA).catch(() => setA({ notfound: true }));
  }, [slug]);

  if (!a) return <div className="py-32 text-center text-[#55524C]">Loading…</div>;
  if (a.notfound) return (
    <div className="py-32 text-center">
      <p className="serif text-3xl">Article not found</p>
      <Link to="/journal" className="link-underline mt-6 inline-block">Back to Journal</Link>
    </div>
  );

  return (
    <article data-testid="journal-detail" className="py-20">
      <div className="max-w-[820px] mx-auto px-6 sm:px-10">
        <Link to="/journal" className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-[#55524C] hover:text-[#2E2B27] transition-colors">
          <ArrowLeft size={14} /> Journal
        </Link>
        <div className="mt-12 label-eyebrow">{a.category} · {a.date}</div>
        <h1 className="serif mt-7 text-[44px] sm:text-[64px] leading-[1.05] tracking-tight">{a.title}</h1>
        <p className="serif italic mt-8 text-[22px] text-[#55524C] leading-snug">{a.excerpt}</p>
      </div>

      <div className="max-w-[720px] mx-auto px-6 sm:px-10 mt-20 text-[18px] leading-[1.9] text-[#2E2B27]">
        <p>{a.content}</p>
        <p className="serif italic text-[18px] text-[#55524C] mt-20">— A. Studio A</p>
        <JournalSubscribe />
      </div>
    </article>
  );
}
